import { render } from "./DialogYesNo.vue?vue&type=template&id=5b9123a2"
import script from "./DialogYesNo.vue?vue&type=script&lang=js"
export * from "./DialogYesNo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__